import PropTypes from "prop-types";

// material-ui
import { Box, Grid } from "@mui/material";

// project import
import AuthCard from "./AuthCard";
import Logo from "./../../components/Logo";

// assets
import AuthBackground from "../../assets/images/auth/AuthBackground";
import UniteLogo from "../../assets/images/auth/UniteLogo.png";
import AppVersion from "../../components/AppVersion";

// ==============================|| AUTHENTICATION - WRAPPER ||============================== //

const AuthWrapper = ({ children, showVersion="false" }) => (
  <Box sx={{ minHeight: "98vh" }}>
    <AuthBackground />
    <Grid
      container
      direction="column"
      justifyContent="flex-end"
      sx={{
        minHeight: "85vh",
      }}
    >
      <Grid item xs={12}>
        <Grid
          item
          xs={12}
          container
          justifyContent="center"
          alignItems="center"
        >
          <Grid item spacing={0} xs={12} sx={{ textAlign: "center" }}>
            <img src={UniteLogo} alt="Kwikset" />
          </Grid>
          <Grid item>
            <AuthCard>{children}</AuthCard>
            {showVersion ? 
              <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mt:-2,
              }}>
                <AppVersion isSignIn={false}/> 
              </Box>
              : ""}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Box>
);

AuthWrapper.propTypes = {
  children: PropTypes.node,
};

export default AuthWrapper;
